import { Component, OnInit, HostBinding, Inject } from '@angular/core';
import { ActivityReportName, ANALYTICS, AnalyticsEvent, IAnalyticsService } from '@libs/portal-common/services';
import { routerTransition } from '@libs/portal-common/system';

import { ActivityFilter } from '../services/call-history.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-daily-activity',
  templateUrl: './daily-activity.component.html',
  animations: [routerTransition],
})
export class DailyActivityComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = '';

  filter = new ActivityFilter();

  constructor(@Inject(ANALYTICS) private analytcis: IAnalyticsService) {}

  ngOnInit() {
    this.analytcis.track(AnalyticsEvent.DailyActivityOpen, { ReportName: ActivityReportName.DailyActivity });
  }

  search(filter: ActivityFilter) {
    this.filter = Object.assign(new ActivityFilter(), filter);
  }

  onFilterChange(filter: ActivityFilter) {
    this.filter = filter;
  }
}
